import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './navbar.css';
import logo from './logo.png';

const Nav = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const toggleMenu = (e) => {
        e.stopPropagation();
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavLinkClick = () => {
        setIsMenuOpen(false);
        window.scrollTo(0, 0);
    };

    const closeMenuOnOutsideClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        const closeMenuOnNavigation = () => {
            setIsMenuOpen(false);
        };

        document.addEventListener('click', closeMenuOnOutsideClick);

        navigate(closeMenuOnNavigation);

        return () => {
            document.removeEventListener('click', closeMenuOnOutsideClick);
            navigate();
        };
    }, [navigate]);

    return (
        <nav className={`navbar ${isMenuOpen ? 'open' : ''}`}>
            <div className="container">
                <div className="logo">
                    <NavLink to="/" onClick={handleNavLinkClick}>
                        <img src={logo} alt="logo" />
                    </NavLink>
                </div>
                <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
                    <li><NavLink to="/" className='link' onClick={handleNavLinkClick}>Home</NavLink></li>
                    <li><NavLink to="/about" className='link' onClick={handleNavLinkClick}>About Us</NavLink></li>
                    <li><NavLink to="/team" className='link' onClick={handleNavLinkClick}>Team</NavLink></li>
                    <li><NavLink to="/contact" className='link' onClick={handleNavLinkClick}>Contact Us</NavLink></li>
                    <li><NavLink to="/register" className='register' onClick={handleNavLinkClick}>Register Now</NavLink></li>
                </ul>
                <div className={`toggle_btn ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>

                    <i className={`fa-solid ${isMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
                </div>
                <div className={`dropdown_menu ${isMenuOpen ? 'open' : ''}`} ref={dropdownRef}>
                    <ul>
                        <li><NavLink to="/" onClick={handleNavLinkClick}><i className="fa-solid fa-house" />Home</NavLink></li>
                        <li><NavLink to="/about" onClick={handleNavLinkClick}><i className="fa-solid fa-user" />About Us </NavLink></li>
                        <li><NavLink to="/team" onClick={handleNavLinkClick}><i className="fa-solid fa-users" />Team</NavLink></li>
                        <li><NavLink to="/contact" onClick={handleNavLinkClick}><i className="fa-solid fa-phone" />Contact Us</NavLink></li>
                        <li><NavLink to="/register" className="register" onClick={handleNavLinkClick}>Register Now</NavLink></li>
                    </ul>
                </div>
            </div>

        </nav>
    );
};

export default Nav;
